// extracted by mini-css-extract-plugin
module.exports = {"videoPlayerCommonStyle":"VideoPlayer_videoPlayerCommonStyle__3O9-0","loomIframeRoot":"VideoPlayer_loomIframeRoot__22y6d","loomIframe":"VideoPlayer_loomIframe__2vaxi"};